import DeviceManager from '../utils/device-manager';
import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class HomePacksSlider {
	constructor($el) {
		this.$el = $el;
        this.$wrapper = this.$el.parent();
        this.$buttons = this.$wrapper.find('.slider__button');
        this.$prev = this.$buttons.find('.slider__button--previous');
        this.$next = this.$buttons.find('.slider__button--next');

		this.options = {
			// autoPlay: true,
			pageDots: false,
			wrapAround: false,
            contain: true,
			prevNextButtons: false,
			freeScroll: true,
			cellSelector: ".pack",
            cellAlign: "left",
		};

		if (this.$el.length) {
			this._init();
            this._bindEvents();
		}
	}

    _init() {
        this.$slides = this.$el.find('.pack');
        this.slidesCount = this.$slides.length;

        // console.log('Nombre de slides HOME PACKS: ' + this.slidesCount);

        if (document.body.clientWidth < 620 && this.slidesCount > 1) {
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('HomePacks - slider mobile');
        } else if (document.body.clientWidth >= 620 && document.body.clientWidth < 800 && this.slidesCount > 2) {
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('HomePacks - slider tablet');
        } else if (document.body.clientWidth >= 800 && document.body.clientWidth < 1024 && this.slidesCount > 3) {
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('HomePacks - slider desktop SM');
        } else if (document.body.clientWidth >= 1024 && document.body.clientWidth < 1700 && this.slidesCount > 4) {
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('HomePacks - slider desktop MD');
        } else if (document.body.clientWidth >= 1700 && this.slidesCount > 5) {
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('HomePacks - slider desktop XL');
        } else {
            // console.log('HomePacks - no packs slider');
        } 
    }

    _bindEvents() {
        this._onBreakpointChangeFn = this._onBreakpointChange.bind(this);

        DeviceManager.on('device-manager:breakpointChange', this._onBreakpointChangeFn);
        
        this.$buttons.on('click', this._onButtonClick.bind(this));
        // this.$buttons.on('click', this._onSelectSlide.bind(this));
    }

    _onButtonClick(e) {
        const $target = $(e.currentTarget);

        if($target.hasClass('slider__button--previous')) {
            this.slider.previous(true);
            // console.log('précédent');
        }
        else if($target.hasClass('slider__button--next')) {
            this.slider.next(true);
            // console.log('suivant');
        }
    }

    _onSelectSlide() {
        // console.log(this.slider.slides);

        /* this.slider.on( 'cellSelect', function() {
            var target = this.slider.selectedCell.target;
            if ( target == flkty.cells[0].target ) {
              console.log('is at contained start')
            } else if ( target == flkty.getLastCell().target ) {
              console.log('is at contained end')
            }
        }); */

        // console.log('INDEX : ' + this.slider.selectedIndex + ' - TOTAL slides: ' + this.slidesCount);

        /*if( this.slider.selectedIndex == this.slidesCount - 1) {
            console.log('TOTO');
            this.$prev.classList.add('disabled');
            this.$next.classList.remove('disabled');
        } else {
            console.log('NADA');
        }*/

        /* this.slider.on('select', function() {
            // enable/disable previous/next buttons
            console.log('INDEX de slide : ' + this.slider.selectedIndex);

            if (!this.slider.slides[this.slider.selectedIndex - 1]) {
                this.$prev.classList.add('disabled');
                this.$next.classList.remove('disabled'); // <-- remove disabled from the next
            } else if (!this.slider.slides[this.slider.selectedIndex + 1]) {
                this.$next.classList.add('disabled');
                this.$prev.classList.remove('disabled'); //<-- remove disabled from the prev
            } else {
                this.$prev.classList.remove('disabled');
                this.$next.classList.remove('disabled');
            }
        }); */
    }

    _destroy() {
        if(this.slider) {
            this.slider.destroy();
            this.slider = null;
        }
    }

	_onBreakpointChange() {
        if (document.body.clientWidth < 620 && this.slidesCount > 1) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('slider resize mobile');
        } else if (document.body.clientWidth >= 620 && document.body.clientWidth < 800 && this.slidesCount > 2) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('slider resize tablet');
        } else if (document.body.clientWidth >= 800 && document.body.clientWidth < 1024 && this.slidesCount > 3) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('slider resize desktop SM');
        } else if (document.body.clientWidth >= 1024 && document.body.clientWidth < 1700 && this.slidesCount > 4) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('slider resize desktop MD');
        } else if (document.body.clientWidth >= 1700 && this.slidesCount > 5) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('slider resize desktop XL');
        } else {
            this._destroy();
            // console.log('HomePacks - no packs slider');
        }
    }
}

export default HomePacksSlider;
